import { render } from "./FooterSection.vue?vue&type=template&id=07f06db9"
import script from "./FooterSection.vue?vue&type=script&lang=js"
export * from "./FooterSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/idse-cgm/webapps/idse-cgm/releases/1793606032402/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__